import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';
import { TRAINING_VIDEO_TIMEOUT_MS } from '@repo/contracts';
import { resolveOnUploadProgress, resolveUploadSignal, uploadAxiosConfig } from '../utils/upload-axios-config.js';

export class TrainingApi extends BaseApi {
    constructor(client) {
        super(client, '/training');
    }

    /**
     * Upload a training video to durable storage.
     * @param {File|Blob} file
     * @param {Function|{ onUploadProgress?: Function, signal?: AbortSignal }} [optionsOrCallback]
     * @returns {Promise<Object>}
     */
    async uploadVideo(file, optionsOrCallback) {
        try {
            const formData = new FormData();
            formData.append('file', file);
            const response = await this.client.post(
                `${this.basePath}/upload-video`,
                formData,
                uploadAxiosConfig({
                    timeout: TRAINING_VIDEO_TIMEOUT_MS,
                    onUploadProgress: resolveOnUploadProgress(optionsOrCallback),
                    signal: resolveUploadSignal(optionsOrCallback),
                    headers: { 'Content-Type': 'multipart/form-data' },
                }),
            );
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    /**
     * Discard an unreferenced uploaded training video.
     * @param {{ storageKey?: string, url?: string }} body
     */
    async discardUploadedVideo(body) {
        try {
            const response = await this.client.delete(`${this.basePath}/uploaded-video`, { data: body });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
